import React from 'react';
import { useClient } from '@context/presentation';
import { useTranslation } from 'react-i18next';
import { isAttorneyProfile } from '@utils/profileUtils';
import { ScriptHeader } from '../styles';
import { Line } from '@slides/styles';

export const SectionOne = ({ termData }) => {
    const { t } = useTranslation();
    const { firmShortName } = useClient();
    const { termLength, termDescription, newMonthlyPayment } = termData;
    const termOrTermRange = isAttorneyProfile(firmShortName) ? termDescription : termLength;

    return (
        <>
            <ScriptHeader> 
                {t('term_options.script.title')}
            </ScriptHeader>
            <Line />
            <div>
                {t('term_options.script.1')} 
                <strong style={{ textDecoration: 'underline'}}>{termOrTermRange}</strong>
                {t('term_options.script.2')}
                <strong style={{ textDecoration: 'underline'}}>{newMonthlyPayment}</strong>
                {t('term_options.script.3')}
            </div>
            <h4>{t('term_options.script.4')}</h4>
            <div>
                {t('term_options.script.5')}
                <strong style={{ textDecoration: 'underline'}}>{termOrTermRange}</strong>
                {t('term_options.script.6')}
            </div>
            <div>
                {t('term_options.script.7')}
                <strong style={{ textDecoration: 'underline'}}>{termOrTermRange}</strong>
                {t('term_options.script.8')}
                <strong style={{ textDecoration: 'underline'}}>{newMonthlyPayment}</strong>
                {t('term_options.script.3')}
            </div>
        </>
    );
};

